import { useContext } from 'react';

import Auth0UserDetailsContext from '@totem/components/services/remoteAccess/auth0users/details/Auth0UserDetailsContext';
import { isNull } from '@totem/utilities/common';

const Auth0UserPageTitle = () => {
  const { user } = useContext(Auth0UserDetailsContext);

  if (isNull(user)) return 'User Details';

  return user.item.name || user.item.email;
};

export default Auth0UserPageTitle;
